import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)
const store = new Vuex.Store({
  state: {
    user: null
  },
  mutations:{
    authorize(state,user){
      state.user = user
      localStorage.setItem('user',JSON.stringify(user))
    },
    deauthorize(state){
      state.user = null
      localStorage.setItem('user',null)
    }
  }
})
export default store
